import React from 'react'
import { Button, transparentize } from 'stylist'
import styled from '@emotion/styled'

const NextButton = styled(Button)`
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-left: 0;
  &:disabled {
    border-color: ${transparentize('slate', 0.1)};
  }
`
const PrevButton = styled(Button)`
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: 0;
  &:disabled {
    border-color: ${transparentize('slate', 0.1)};
  }
`

const Pagination = ({
  hasNextPage,
  hasPreviousPage,
  onNextClick,
  onPrevClick
}) => (
  <div>
    <PrevButton
      onClick={onPrevClick}
      kind="standard"
      disabled={!hasPreviousPage}
    >
      ◀
    </PrevButton>
    <NextButton onClick={onNextClick} kind="standard" disabled={!hasNextPage}>
      ▶
    </NextButton>
  </div>
)

export default Pagination



// WEBPACK FOOTER //
// ./src/components/Pagination.js